<script>
	
	import NewBatchForm from "./Form/index.svelte"
	import NewBatchImport from "./Import/index.svelte"
	import {setState, getState} from "../../../../stores.js";


	/*
		newBatchType - Type of new Batch

		0 - option state
		1 - Import CSV File selected
		2- 	Add New Batch selected
		
		default state - 0
	*/

	export let newBatchType = 0;

	export let newBatchOpen = false; 



	function optionSelected(e){

		newBatchType = e.target.id;
		setState('newBatchType', newBatchType);

	}




</script>



<div class="newbatchContainer">

	{#if newBatchType == 0 }
		<div class="actionsContainer">

			<div class="actionBtn">
				<div class="actionBtnTxt" on:click={(e)=> optionSelected(e)} id="1">
					Import File	
				</div>

				<div class="actionBtnIcon" on:click={(e)=> optionSelected(e)} id="1">
					<!-- <div class="uploadIcon">
						
					</div> -->
					<i class="fa-solid fa-file-arrow-up"></i>
				</div>
				
			</div>

			<div class="actionBtn">
				
				<div class="actionBtnTxt" on:click={(e)=> optionSelected(e)} id="2">
					Add new batch	
				</div>

				<div class="actionBtnIcon" on:click={(e)=> optionSelected(e)} id="2">
					<!-- <div class="addIcon">
						
					</div> -->
					<i class="fa-solid fa-circle-plus"></i>
				</div>
			</div>
		</div>
	{:else if newBatchType == 1} <!-- Import CSV file --> 
		<NewBatchImport bind:newBatchOpen={newBatchOpen}/>
	{:else if newBatchType == 2} <!-- Add new batch -->
		<NewBatchForm bind:newBatchOpen={newBatchOpen}/>
	{:else}
		<div>error</div>
	{/if}

</div>

<style>

	.newbatchContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: center;
	}

	.actionsContainer{
		width: 90%;
		height: 50%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-evenly;
	}

	.actionBtn{
		width: 150px;
		height: 150px;
		display: flex;
		flex-direction: column;
		align-items: center;
		/*background-color: white;*/
		background-color: var(--brand);
		border-radius: 10px;
		cursor: pointer;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.actionBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
	}

	.actionBtnTxt{
		width: 100%;
		height: 50%;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		color: #1F1F1F;
		font-size: 0.9114583333333334vw;
		font-weight:900;
		background-color: transparent;
	}

	.actionBtnIcon{
		width: 100%;
		height: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		/*background-color: red;*/
	}

	.actionBtnIcon > i {
		transform: scale(1.2);
	}

	.uploadIcon{
		width: 48px;
		height: 48px;
		background-image: url(/img/icons/upload.png);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
	}

	.addIcon{
		width: 48px;
		height: 48px;
		background-image: url(/img/icons/add.png);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
	}

</style>